import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { PAYMENTS } from 'self-service-api/constants/Features';
import ChecklistItemTranslated from '../../common/ChecklistItemTranslated';
import { jsx as _jsx } from "react/jsx-runtime";
const BusinessObjectivesFeatures = ({
  features
}) => {
  return /*#__PURE__*/_jsx(UIList, {
    children: features.map(feature => {
      const secondaryMessage = feature.shortName === PAYMENTS ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.businessObjectives.usOnly"
      }) : null;
      return /*#__PURE__*/_jsx(UIFlex, {
        className: "m-y-1",
        children: /*#__PURE__*/_jsx(ChecklistItemTranslated, {
          tooltipMessage: /*#__PURE__*/_jsx(SanitizedText, {
            body: feature.description,
            formattingOptions: {
              isPlainText: false,
              shouldPreserveNewlines: true,
              shouldOpenLinksInNewTab: true
            }
          }),
          message: feature.displayName,
          secondaryMessage: secondaryMessage
        })
      }, feature.featureId);
    })
  });
};
export default BusinessObjectivesFeatures;